import React, { Component } from 'react';
import Authentication from '../Authentication'
import Login from '../Login'
import ChangePass from '../LinkchangePass'
import ForgotPass from '../LinkForgotPass'
import Modules from '../Modules'

class catalogSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title,
      modulo:{},
      user:{}
    }
  }

  changeToIndex(title) {
    this.setState({
      title: title
    });

  }

  changeToModule(title,modulo,user) {
    this.setState({
      title: title,
      modulo: modulo,
      user:user
    });
  }
 

  componentWillReceiveProps(nextProps) {
    this.setState({ title: nextProps.title })    
  }

    renderSwitch(param) {      
        switch (param) {
            case 'Member Authentication':
                return <Authentication redirectTo={this.changeToIndex.bind(this)} modulo={this.state.modulo} user={this.state.user} />
            case 'Login':
                return <Login redirectTo={this.changeToIndex.bind(this)} />
            case 'ChangePass':
                return <ChangePass redirectTo={this.changeToIndex.bind(this)} />
            case 'ForgotPass':
                 return <ForgotPass redirectTo={this.changeToIndex.bind(this)} />
            case 'Modules':
                 return <Modules redirectTo={this.changeToModule.bind(this)} />

            default:
                return <Login  redirectTo={this.changeToIndex.bind(this)} />;
        }
    }


  render() {
    return (
   
        <section className="col-12">
            {this.renderSwitch(this.state.title)}
        </section>

    );
  }
}

export default catalogSection;


// WEBPACK FOOTER //
// ./src/components/Catalog/CatalogSection.js